

import Component from 'generic.basecomponent';


export default class Tabs extends Component {
    constructor(el, callbacks) {
        super(el);
        this.callbacks = callbacks;
        this.initTabs();
    }

    initTabs() {
        this.defineVariables();
        Array.prototype.forEach.call(this.tabs, (tab) => {
            tab.addEventListener('click', this.setTab.bind(this));
        }, this);

        if (this.activeTabHash !== '' && this.supportTags) {
            this.setTab(this.activeTabHash);
        } else {
            this.setTab(this.defaultActive);
        }
    }

    defineVariables() {
        this.activeClass = 'js-active';
        this.supportTags = false;
        this.defaultActive = 0;
        this.tabs = this.container.querySelectorAll('.js-button');
        this.panels = this.container.querySelectorAll('.js-panel');
        this.activeTabHash = window.location.hash;
    }

    setTab(e) {
        if (e.target) {
            this.currentTab = e.target.getAttribute('href').substr(1);
            this.setActiveClass();
        } else if (typeof e === 'number') {
            this.currentTab = this.tabs[e].getAttribute('href').substr(1);
            this.setActiveClass();
        } else if (typeof e === 'string') {
            for (const tab of this.tabs) {
                if (tab.hash === this.activeTabHash) {
                    this.currentTab = tab.hash.substring(1);
                    this.setActiveClass();
                }
            }
        }

        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (typeof this.callbacks === 'object' && typeof this.callbacks[this.currentTab] === 'function') {
            this.callbacks[this.currentTab]();
        }
    }

    setActiveClass() {
        for (let i = 0; i < this.panels.length; i++) {
            if (this.panels[i].id === this.currentTab) {
                this.panels[i].classList.add(this.activeClass);
                this.tabs[i].classList.add(this.activeClass);
                this.panels[i].style.display = 'block';
            } else {
                this.panels[i].classList.remove(this.activeClass);
                this.tabs[i].classList.remove(this.activeClass);
                this.panels[i].style.display = 'none';
            }
        }
    }
}


Tabs.id = 0;



// WEBPACK FOOTER //
// ./app/components/tabs/js/generic.tabs.js